import {ApolloLink} from '@apollo/client';

import interopFields from '../../../schema/interop.json';
import createTransformRestQueryLink from './links/RestLink/createTransformRestQueryLink';
import createContextHeadersLink from './links/createContextHeadersLink';
import createRestLink from './links/RestLink/createRestLink';
import createMissingAnnotationLink from '../../shared/graphql/links/createMissingAnnotationLink';
import createAbortNetworkFetchLink from '../../shared/graphql/links/createAbortNetworkFetchLink';
import createV1ContextMismatchTelemetryLink from '../../shared/graphql/links/createV1ContextMismatchTelemetryLink';
import createWaitForInteropAccountLink from '../../shared/graphql/links/createWaitForInteropAccountLink';
import type {
  UnionObjectTypesMap,
  FieldVersionOverrides,
} from '../../shared/graphql/links/RestLink/types';
import type {TopLevelFieldToArgs} from '../../shared/graphql/links/RestLink/removePbeFromParams';

export default function createV1ApolloLink(
  unionObjectTypesMap: UnionObjectTypesMap,
  pbeMap: Record<string, ReadonlyArray<string>>,
  topLevelFieldToArgs: TopLevelFieldToArgs,
  fieldVersionOverrides: FieldVersionOverrides,
  shadowComparisonOperationsV1ToV2: Record<string, boolean>,
) {
  const queryEndpointsToBeRequestedWithPost = [
    '/ajax/payment_intents_with_legacy_charges',
  ];

  return ApolloLink.from([
    createV1ContextMismatchTelemetryLink(),
    createContextHeadersLink(),
    createWaitForInteropAccountLink(interopFields),
    createTransformRestQueryLink(),
    createAbortNetworkFetchLink(),
    createRestLink(
      unionObjectTypesMap,
      pbeMap,
      topLevelFieldToArgs,
      fieldVersionOverrides,
      queryEndpointsToBeRequestedWithPost,
      shadowComparisonOperationsV1ToV2,
      interopFields,
    ),
    createMissingAnnotationLink(),
  ]);
}
